<template>
    <div
        v-if="appParams && appParams.staticTranslations"
        class="container pt-4 pb-5"
        id="itb-privacy-policy"
    >
        <h1>{{ appParams.staticTranslations["privacy_policy.text_001"] }}</h1>
        <p style="opacity: 0.5">
            {{ appParams.staticTranslations["privacy_policy.text_002"] }}
        </p>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_003"] }}
        </p>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_004"] }}
            <a
                href="https://www.privacypolicies.com/blog/privacy-policy-template/"
                target="_blank"
                >{{
                    appParams.staticTranslations["privacy_policy.text_005"]
                }}</a
            >.
        </p>
        <h2>{{ appParams.staticTranslations["privacy_policy.text_006"] }}</h2>
        <h3>{{ appParams.staticTranslations["privacy_policy.text_007"] }}</h3>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_008"] }}
        </p>
        <h3>{{ appParams.staticTranslations["privacy_policy.text_009"] }}</h3>
        <p>{{ appParams.staticTranslations["privacy_policy.text_010"] }}</p>
        <ul>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_011"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_012"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations[
                            "privacy_policy.text_013"
                        ] + " "
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_014"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_015"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_016"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_017"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_018"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_019"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_020"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_021"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_022"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_023"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_024"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_025"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_026"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_027"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_028"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_029"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_030"]
                    }}
                    <a
                        href="https://epdm-graphics.com/"
                        rel="nofollow noopener"
                        target="_blank"
                        >https://epdm-graphics.com/</a
                    >
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_031"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_032"]
                    }}
                </p>
            </li>
        </ul>
        <h2>{{ appParams.staticTranslations["privacy_policy.text_033"] }}</h2>
        <h3>{{ appParams.staticTranslations["privacy_policy.text_034"] }}</h3>
        <h4>{{ appParams.staticTranslations["privacy_policy.text_035"] }}</h4>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_036"] }}
        </p>
        <ul>
            <li>
                <p>
                    {{
                        appParams.staticTranslations["privacy_policy.text_037"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    {{
                        appParams.staticTranslations["privacy_policy.text_038"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    {{
                        appParams.staticTranslations["privacy_policy.text_039"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    {{
                        appParams.staticTranslations["privacy_policy.text_040"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    {{
                        appParams.staticTranslations["privacy_policy.text_041"]
                    }}
                </p>
            </li>
        </ul>
        <h4>{{ appParams.staticTranslations["privacy_policy.text_041"] }}</h4>
        <p>{{ appParams.staticTranslations["privacy_policy.text_042"] }}</p>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_043"] }}
        </p>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_044"] }}
        </p>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_045"] }}
        </p>
        <h4>{{ appParams.staticTranslations["privacy_policy.text_046"] }}</h4>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_047"] }}
        </p>
        <ul>
            <li>
                <strong>{{
                    appParams.staticTranslations["privacy_policy.text_051"]
                }}</strong
                >{{ appParams.staticTranslations["privacy_policy.text_048"] }}
            </li>
            <li>
                <strong>{{
                    appParams.staticTranslations["privacy_policy.text_049"]
                }}</strong
                >{{ appParams.staticTranslations["privacy_policy.text_050"] }}
                <a
                    href="https://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html#main_Where_can_I_change_the_settings_for_disabling__or_deleting_local_shared_objects_"
                    rel="external nofollow noopener"
                    target="_blank"
                    >https://helpx.adobe.com/flash-player/kb/disable-local-shared-objects-flash.html#main_Where_can_I_change_the_settings_for_disabling__or_deleting_local_shared_objects_</a
                >
            </li>
            <li>
                <strong>{{
                    appParams.staticTranslations["privacy_policy.text_052"]
                }}</strong
                >{{ appParams.staticTranslations["privacy_policy.text_053"] }}
            </li>
        </ul>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_054"] }}
            <a
                href="https://www.privacypolicies.com/blog/privacy-policy-template/#Use_Of_Cookies_Log_Files_And_Tracking"
                rel="external nofollow noopener"
                target="_blank"
                >{{
                    appParams.staticTranslations["privacy_policy.text_055"]
                }}</a
            >.
        </p>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_056"] }}
        </p>
        <ul>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_057"]
                    }}</strong>
                </p>
                <p>
                    {{
                        appParams.staticTranslations["privacy_policy.text_058"]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations["privacy_policy.text_059"]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations["privacy_policy.text_060"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_061"]
                    }}</strong>
                </p>
                <p>
                    {{
                        appParams.staticTranslations["privacy_policy.text_062"]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations["privacy_policy.text_059"]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations["privacy_policy.text_063"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_064"]
                    }}</strong>
                </p>
                <p>
                    {{
                        appParams.staticTranslations["privacy_policy.text_062"]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations["privacy_policy.text_059"]
                    }}
                </p>
                <p>
                    {{
                        appParams.staticTranslations["privacy_policy.text_065"]
                    }}
                </p>
            </li>
        </ul>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_066"] }}
        </p>
        <h3>{{ appParams.staticTranslations["privacy_policy.text_067"] }}</h3>
        <p>{{ appParams.staticTranslations["privacy_policy.text_068"] }}</p>
        <ul>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_069"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_070"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_071"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_072"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_073"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_074"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_075"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_076"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_077"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_078"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_079"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_080"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_081"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_082"]
                    }}
                </p>
            </li>
            <li>
                <p>
                    <strong>{{
                        appParams.staticTranslations["privacy_policy.text_083"]
                    }}</strong
                    >{{
                        appParams.staticTranslations["privacy_policy.text_084"]
                    }}
                </p>
            </li>
        </ul>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_085"] }}
        </p>
        <ul>
            <li>
                <strong>{{
                    appParams.staticTranslations["privacy_policy.text_086"]
                }}</strong
                >{{ appParams.staticTranslations["privacy_policy.text_087"] }}
            </li>
            <li>
                <strong>{{
                    appParams.staticTranslations["privacy_policy.text_088"]
                }}</strong
                >{{ appParams.staticTranslations["privacy_policy.text_089"] }}
            </li>
            <li>
                <strong>{{
                    appParams.staticTranslations["privacy_policy.text_090"]
                }}</strong
                >{{ appParams.staticTranslations["privacy_policy.text_091"] }}
            </li>
            <li>
                <strong>{{
                    appParams.staticTranslations["privacy_policy.text_092"]
                }}</strong
                >{{ appParams.staticTranslations["privacy_policy.text_093"] }}
            </li>
            <li>
                <strong>{{
                    appParams.staticTranslations["privacy_policy.text_094"]
                }}</strong
                >{{ appParams.staticTranslations["privacy_policy.text_095"] }}
            </li>
            <li>
                <strong>{{
                    appParams.staticTranslations["privacy_policy.text_096"]
                }}</strong
                >{{ appParams.staticTranslations["privacy_policy.text_097"] }}
            </li>
        </ul>
        <h3>{{ appParams.staticTranslations["privacy_policy.text_098"] }}</h3>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_099"] }}
        </p>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_100"] }}
        </p>
        <h3>{{ appParams.staticTranslations["privacy_policy.text_101"] }}</h3>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_102"] }}
        </p>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_103"] }}
        </p>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_104"] }}
        </p>
        <h3>{{ appParams.staticTranslations["privacy_policy.text_105"] }}</h3>
        <h4>{{ appParams.staticTranslations["privacy_policy.text_106"] }}</h4>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_107"] }}
        </p>
        <h4>{{ appParams.staticTranslations["privacy_policy.text_108"] }}</h4>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_109"] }}
        </p>
        <h4>{{ appParams.staticTranslations["privacy_policy.text_110"] }}</h4>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_111"] }}
        </p>
        <ul>
            <li>
                {{ appParams.staticTranslations["privacy_policy.text_112"] }}
            </li>
            <li>
                {{ appParams.staticTranslations["privacy_policy.text_113"] }}
            </li>
            <li>
                {{ appParams.staticTranslations["privacy_policy.text_114"] }}
            </li>
            <li>
                {{ appParams.staticTranslations["privacy_policy.text_115"] }}
            </li>
            <li>
                {{ appParams.staticTranslations["privacy_policy.text_116"] }}
            </li>
        </ul>
        <h3>{{ appParams.staticTranslations["privacy_policy.text_117"] }}</h3>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_118"] }}
        </p>
        <h2>{{ appParams.staticTranslations["privacy_policy.text_119"] }}</h2>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_120"] }}
        </p>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_121"] }}
        </p>
        <h2>{{ appParams.staticTranslations["privacy_policy.text_122"] }}</h2>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_123"] }}
        </p>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_124"] }}
        </p>
        <h2>{{ appParams.staticTranslations["privacy_policy.text_125"] }}</h2>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_126"] }}
        </p>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_127"] }}
        </p>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_128"] }}
        </p>

        <h3>{{ appParams.staticTranslations["privacy_policy.text_129"] }}</h3>
        <p>
            {{ appParams.staticTranslations["privacy_policy.text_130"] }}
            <a href="mailto:graphics@4soft.cz">graphics@4soft.cz</a>
        </p>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {};
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams",
        }),
    },

    mounted() {
        axios
            .get("/getPrivacyPolicyPage")
            .then((response) => {
                // this.heroCards = response.data.heroCards;
                this.pageParams = response.data.params;
                this.setPageParams(this.pageParams);
            })
            .catch((error) => {
                console.log(error);
            });
    },
    methods: {
        ...mapActions(["setPageParams", "setFormParams"]),
    },
};
</script>
